// src/authConfig.js
import { LogLevel } from "@azure/msal-browser";

// Use absolute URLs based on window.location.origin
const redirectUri = process.env.REACT_APP_REDIRECT_URI || `${window.location.origin}/`;
const postLogoutRedirectUri = process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || `${window.location.origin}/`;

const authority = process.env.REACT_APP_B2C_AUTHORITY || "";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_B2C_CLIENT_ID || "",
    authority: authority,
    knownAuthorities: authority ? [new URL(authority).hostname] : [],
    redirectUri: redirectUri,
    postLogoutRedirectUri: postLogoutRedirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage", // Better for security - clears when tab closes
    storeAuthStateInCookie: false,   // Only true if you need IE11 support
  },
  system: {
    loggerOptions: {
      loggerCallback: (_level, _message, containsPii) => {
        if (containsPii) return; // Never log PII
        // MSAL logging disabled - no console output
      },
      logLevel: LogLevel.Error, // Only log critical errors
    },
  },
};

const apiConfig = {
  b2cScopes: (process.env.REACT_APP_B2C_SCOPES || "").split(",").filter(Boolean),
  webApiUri: process.env.REACT_APP_B2C_WEB_API_URI || ""
};

export const loginRequest = {
  scopes: [ "openid", "offline_access", ...apiConfig.b2cScopes ]
}

export const tokenRequest = {
  scopes: [ "openid", "offline_access", ...apiConfig.b2cScopes ]
}